import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	archived: {
		id: 'search-page.filters.names.archived',
		defaultMessage: 'Show archived content',
		description: 'Label for filtering by archived or current content',
	},
});
